export default __webpack_public_path__ + "static/media/portfolio.bb7d0db8.png";